import React, { useState, useEffect, useContext } from "react";
import Swal from "sweetalert2";
import { PlayCircleFill } from "react-bootstrap-icons";
import { BiTime, BiXCircle } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import withReactContent from "sweetalert2-react-content";
import '../styles/VideoCard.css';
import NavbarComp1 from "../components/Navbar1";
import { Container, Card, Form, Button, Row, Col, Nav, Dropdown } from "react-bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";
// import { getUserSession } from "../pages/auth";
import { UserContext } from "../jsx/UserContext";
import api from "../jsx/axiosClient";
import DashboardStatus from "../components/DashboardStatus";
import IslRecentVideos from "../components/ISLRecentVideos";
import IslFileUploadForm from "../components/ISLFileUploadForm";
import '../css/main.css';
import {IslFileUploadHandler } from "../utils/IslFileUploadHandler"; 
import Footer from "../components/Footer";

function Islvideo() {
  const { userSession } = useContext(UserContext); // âœ… get token from context
  //const [stats, setStats] = useState({});
    const [activeTab, setActiveTab] = useState("media");

  const [recentVideos, setRecentVideos] = useState([]); // Recent videos (API values will overwrite this)
const baseUrl = "https://stagingapi.chalachitravaachana.org/";
  const navigate = useNavigate();
  const upload = IslFileUploadHandler(userSession,activeTab); // ✅ Use custom hook
    const [isl_dashboard_data , setIsl_dashboard_data] = useState([]);

  const MySwal = withReactContent(Swal);

  const [stats, setStats] = useState({
    uploaded: 0,
    processing: 0,
    published: 0,
    corrupted: 0,
  });

  useEffect(() => {
    const fetchDashboardData = async () => {
      if (!userSession?.access_token) return;

      try {
        console.log(" access_token ISL Dashboard:", userSession.access_token);
        const response = await api.get("/isl-dashboard", {
          headers: {
            Authorization: `Bearer ${userSession.access_token}`,
             withCredentials: true,
          },
        });


        const result = response.data;
        console.log("ISL Dashboard response:", result);
                    setIsl_dashboard_data(result);

        if (result.status === "success") {
          setStats({
            uploaded: result.data.stat.uploaded || 0,
            processing: result.data.stat.inprogress || 0,
            published: result.data.stat.published || 0,
            corrupted: result.data.stat.failed || 0,
          });

          const files = result.data.files || [];
          console.log("ISL files", files);
         const mappedVideos = files
        .map((file) => {
         // const numericSize = parseFloat(file.size); // extracts 10 from "10 MB"

          return {
            id: file.id,
            title: file.name,
            thumbnail_url: file.thumbnail_url ? `${baseUrl}${file.thumbnail_url}` : null,
            status: file.status,
            video_url: file.video_url,
            size: file.size,
            progress: file.progress,
          };
        });
       //.sort((a, b) => b.size - a.size);

          console.log("ISL mappedVideos", mappedVideos);

          setRecentVideos(mappedVideos);
        } else {
          Swal.fire({
            icon: "error",
            title: "Failed",
            text: result.message || "Could not fetch dashboard data.",
          });
        }
      } 
      // catch (error) {
      //   console.error("Dashboard fetch error:", error);
      //   Swal.fire({
      //     icon: "error",
      //     title: "Error",
      //     text:
      //       error.response?.data?.message ||
      //       "Unable to load dashboard data. Please try again later.",
      //   });
      // }
catch (error) {
    console.error("Dashboard fetch error:", error);

    // 🔥 If token expired or unauthorized → redirect to login
    if (error.response?.status === 401 || 
        error.response?.data?.message?.toLowerCase().includes("token") ||
        error.response?.data?.message?.toLowerCase().includes("expired") ||
        error.response?.data?.message?.toLowerCase().includes("unauthenticated")) 
    {
        // Swal.fire({
        //     icon: "warning",
        //     title: "Session Expired",
        //     text: "Please login again.",
        // });

        localStorage.removeItem("userSession");  // clear session
        window.location.href = "/login";         // redirect
        return;
    }

    Swal.fire({
        icon: "error",
        title: "Error",
        text:
            error.response?.data?.message ||
            "Unable to load dashboard data. Please try again later.",
    });
}
    };

    fetchDashboardData();
  }, [userSession]);





  // ðŸ”¹ Media form states
  const [file, setFile] = useState(null);
  const [fileError, setFileError] = useState(false);
  const [mediaTitle, setMediaTitle] = useState("");
  const [mediaTitleError, setMediaTitleError] = useState(false);
  const [mediaDescription, setMediaDescription] = useState("");
  const [mediaDescriptionError, setMediaDescriptionError] = useState(false);
  //const [mediaNarrator, setMediaNarrator] = useState("Amrita Model 1");
  const [mediaNarrator, setMediaNarrator] = useState("m1");

  // ðŸ”¹ YouTube form states
  const [youtubeUrl, setYoutubeUrl] = useState("");
  const [youtubeUrlError, setYoutubeUrlError] = useState(false);
  const [ytTitle, setYtTitle] = useState("");
  const [ytTitleError, setYtTitleError] = useState(false);
  const [ytDescription, setYtDescription] = useState("");
  const [ytDescriptionError, setYtDescriptionError] = useState(false);
  const [ytNarrator, setYtNarrator] = useState("m1");
  //const [ytNarrator, setYtNarrator] = useState("Amrita Model 1");
  const [dragging, setDragging] = useState(false);

  // Handle drop (media only)
  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      setFile(e.dataTransfer.files[0]);
      setFileError(false);
    }
  };
  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFile(e.target.files[0]);
      setFileError(false);
    }
  };

  const handleSubmit = async (type) => {
    let valid = true;
    let formData = new FormData();

    if (type === "media") {
      if (!file) {
        setFileError(true);
        valid = false;
      }
      if (!mediaTitle.trim()) {
        setMediaTitleError(true);
        valid = false;
      }
    
      if (!valid) return;

      // Append media fields
      formData.append("file_path", file);
      formData.append("title", mediaTitle);
      formData.append("description", mediaDescription);
      formData.append("narrator", mediaNarrator);

    } else {
      if (!youtubeUrl.trim()) {
        setYoutubeUrlError(true);
        valid = false;
      }
      if (!ytTitle.trim()) {
        setYtTitleError(true);
        valid = false;
      }
     
      if (!valid) return;

      // Append YouTube fields
      formData.append("youtube_path", youtubeUrl);
      formData.append("title", ytTitle);
      formData.append("description", ytDescription);
      formData.append("narrator", ytNarrator);
  
    }

    console.log("ISL FormData contents:");
    for (let [key, val] of formData.entries()) {
      console.log(key, val);
    }
    try {
      MySwal.fire({
        title: "Uploading...",
        text: "Please wait while we process your request",
        allowOutsideClick: false,
        didOpen: () => MySwal.showLoading(),
      });

      const response = await api.post("/convert-isl-file", formData, {
        headers: {
          Authorization: `Bearer ${userSession.access_token}`,
        },
        withCredentials: true, 
      });

      const result = response.data;
      console.log("File upload result:", result);

      if (result.status === "success") {
        MySwal.close();
        await MySwal.fire({
          icon: "success",
          title: "Upload Successful",
          text: result.message || `${type === "media" ? "Media" : "YouTube"} uploaded successfully!`,
          confirmButtonText: "OK",

        });
     
  window.location.reload(); 
        
      } else {
        MySwal.fire({
          icon: "error",
          title: "Upload Failed",
          text: result.message || "Something went wrong. Please try again.",
        });
      }
    } catch (error) {
      console.error("Upload error:", error);
      MySwal.fire({
        icon: "error",
        title: "Server Error",
        text: error.response?.data?.message || "Could not connect to backend. Please try again later.",
      });
    }
  };

  // Pagination
  const videosPerPage = 6;
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(recentVideos.length / videosPerPage);
  const indexOfLastVideo = currentPage * videosPerPage;
  const indexOfFirstVideo = indexOfLastVideo - videosPerPage;
  const currentVideos = recentVideos.slice(indexOfFirstVideo, indexOfLastVideo);

// useEffect(() => {
//     // APPLY STYLES ONLY WHEN THIS PAGE IS OPEN
//     document.body.style.overflow = "hidden";
//     document.getElementById("root").style.height = "100%";
//     document.getElementById("root").style.overflow = "hidden";

//     // Apply styles to container-fluid
//     const containers = document.querySelectorAll(".container-fluid");
//     containers.forEach((el) => {
//       el.style.flex = "1";
//       el.style.overflow = "auto";
//     });

//     // CLEANUP — REMOVE STYLES WHEN LEAVING THIS PAGE
//     return () => {
//       document.body.style.overflow = "";
//       document.getElementById("root").style.height = "";
//       document.getElementById("root").style.overflow = "";

//       containers.forEach((el) => {
//         el.style.flex = "";
//         el.style.overflow = "";
//       });
//     };
//   }, []);
// useEffect(() => {
//   // DO NOT BLOCK BODY SCROLL
//   document.body.style.overflow = "auto";

//   const root = document.getElementById("root");
//   root.style.height = "auto";
//   root.style.overflow = "visible";

//   // Apply scroll only to main content container
//   const containers = document.querySelectorAll(".container-fluid");
//   containers.forEach((el) => {
//     el.style.flex = "1";
//     el.style.overflowY = "auto";
//   });

//   return () => {
//     document.body.style.overflow = "";
//     root.style.height = "";
//     root.style.overflow = "";

//     containers.forEach((el) => {
//       el.style.flex = "";
//       el.style.overflow = "";
//     });
//   };
// }, []);

  return (
       <div className="page-wrapper">
    {/* Skip to main content */}
    <a
      href="#main-content"
      className="visually-hidden-focusable"
      style={{
        position: "absolute",
        top: "-40px",
        left: "0",
        background: "#000",
        color: "#fff",
        padding: "8px 16px",
        zIndex: "1000",
        borderRadius: "4px",
      }}
      onFocus={(e) => (e.target.style.top = "0")}
      onBlur={(e) => (e.target.style.top = "-40px")}
    >
      Skip to main content
    </a>
          <div className="content-wrapper">
   <div className="main-div">
   
      <NavbarComp1 /> 
      {/* <Container style={{ marginTop: "30px", maxWidth:"100%" }}>
        <DashboardStatus stats={stats} />
<Row className="equal-columns g-3">
<Col md={4} className="upload-col">
            <IslFileUploadForm
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              {...upload}
            />
          </Col>
<Col md={8} className="videos-col">
             <IslRecentVideos
                  videos={recentVideos}
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={setCurrentPage}
                />
          </Col>
        </Row>

      </Container> */}
 <Container fluid
   id="main-content"
          role="main"
          aria-labelledby="islDashboardHeading"
  className="p-3 " 
 style={{ background: "#f8f9fc" }}>
  
          <h1 id="islDashboardHeading" className="visually-hidden">
            ISL 2D Dashboard
          </h1>
      <Row>
 <Col md={5} className="mb-3 "
  role="region"
              aria-labelledby="uploadSectionHeading"
 >
   <h2 id="uploadSectionHeading" className="visually-hidden">
                Upload Video
              </h2>
   <IslFileUploadForm
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              isldashboardData={isl_dashboard_data}
              {...upload}
            />

    </Col>
        <Col md={7}  role="region"
              aria-labelledby="videosSectionHeading">
                 <h2 id="videosSectionHeading" className="visually-hidden">
                Dashboard statistics and recent videos
              </h2>
                <DashboardStatus stats={stats} />

           <IslRecentVideos
                  videos={recentVideos}
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={setCurrentPage}
                />
        </Col>
      </Row>
    </Container> 
  <Footer />

    </div>
    </div>
    </div>
  );
}

export default Islvideo;
